import classNames from 'classnames';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';

export const useResponsiveStyleWrapper = (getStylesFunction) => {
  const getResponsiveStyles = useResponsiveStyles(getStylesFunction);

  return className => classNames(getResponsiveStyles(className));
};
